import type { ImageRefDto } from '../../../shared/models/marketing.models';
import type { StoryCardModel } from '../success-stories/success-stories.utils';

export type MarketingTestimonialItem = {
  studentName: string;
  pill?: string;
  country?: string;
  university?: string;
  course?: string;
  review: string;
  rating: number;
  avatar?: ImageRefDto;
};

export type MarketingStoryDetail = {
  kind: 'success-story' | 'testimonial';
  name: string;
  description: string;
  image?: ImageRefDto;
  category?: string;
  university?: string;
  country?: string;
  program?: string;
  intake?: string;
  rating?: number;
  meta?: string;
  ctaHref?: string;
  ctaLabel?: string;
};

export function detailFromStoryCard(story: StoryCardModel): MarketingStoryDetail {
  return {
    kind: story.kind ?? 'success-story',
    name: story.name,
    description: story.description,
    image: story.image,
    category: story.category ?? story.pill,
    university: story.university,
    country: story.country,
    program: story.course,
    intake: story.intake,
    rating: story.rating,
    meta: story.meta,
    ctaHref: story.ctaHref,
    ctaLabel: story.ctaLabel,
  };
}

export function detailFromTestimonial(item: MarketingTestimonialItem): MarketingStoryDetail {
  const pill = item.pill?.trim() || undefined;
  return {
    kind: 'testimonial',
    name: item.studentName,
    description: item.review,
    image: item.avatar,
    category: pill,
    university: item.university?.trim() || undefined,
    country: item.country?.trim() || undefined,
    program: item.course?.trim() || undefined,
    rating: item.rating,
    meta: [item.university?.trim(), item.country?.trim()].filter(Boolean).join(', ') || item.course?.trim(),
  };
}
